<template>
  <div>
    <div class="clearfix"></div>
    <div class="row" v-if="fileId">
      <div class="col-md-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            <h3 class="pull-left">{{ $t("file_details") }}</h3>
            <h3
              v-if="fileData.status == 'completed'"
              class="text-success pull-right"
            >
              <i class="fas fa-check-circle"></i> {{ $t("completed") }}
            </h3>
            <h3
              v-if="fileData.status == 'pending'"
              class="text-pending pull-right"
            >
              <i class="fas fa-clock"></i> {{ $t("pending") }}
            </h3>
            <h3
              v-if="fileData.status == 'canceled'"
              class="text-error pull-right"
            >
              <i class="fas fa-times"></i> {{ $t("canceled") }}
            </h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{ $t("description") }}</th>
                  <th>{{ $t("value") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{{ $t("file_code") }}</th>
                  <td>{{ fileData.code }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("upload_date_time") }}</th>
                  <td>{{ fileData.created_at }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("status") }}</th>
                  <td>
                    <nobr>
                      <span
                        v-if="fileData.status === 'completed'"
                        class="text-success"
                        ><i class="fas fa-check-circle"></i
                      ></span>
                      <span
                        v-if="fileData.status === 'pending'"
                        class="text-pending"
                        ><i class="fas fa-clock"></i
                      ></span>
                      <span
                        v-if="fileData.status === 'canceled'"
                        class="text-error"
                        ><i class="fas fa-times"></i
                      ></span>
                      &nbsp; {{ $t(fileData.status) }}
                    </nobr>
                  </td>
                  <td></td>
                </tr>
                <tr class="column-title">
                  <td colspan="3" class="text-center">
                    <h5>{{ $t("your_uploaded_files") }}</h5>
                  </td>
                </tr>
                <tr v-for="(file, key) in fileData.files">
                  <th scope="row">{{ $t("file") }} {{ parseInt(key + 1) }}</th>
                  <td :alt="file.name" :title="file.name">
                    {{ file.name | truncate(75) }}
                  </td>
                </tr>
                <tr class="column-title">
                  <td colspan="3" class="text-center">
                    <h5>{{ $t("returned_files_by_our_engineers") }}</h5>
                  </td>
                </tr>
                <tr v-for="(child, key) in fileData.children">
                  <th scope="row">
                    {{ $t("collection") }} {{ parseInt(key + 1) }}
                    <div class="credits">
                      {{ child.credits }} {{ $t("credits") }}
                    </div>
                  </th>
                  <td>
                    <div v-for="childFile in child.files" :key="childFile.id">
                      <div
                        class="pull-left"
                        :alt="childFile.name"
                        :title="childFile.name"
                      >
                        {{ childFile.name | truncate(75) }}<br />
                        <div class="adminNotes" v-if="child.admin_notes">
                          {{ $t("admin_notes") }}: {{ child.admin_notes }}
                        </div>
                      </div>
                      <div
                        class="pull-right pointer btn btn-primary"
                        :data-tooltip="$t('download')"
                        @click="downloadFiles(child.id, childFile.name)"
                      >
                        <i class="fas fa-download"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

      <div class="col-md-12 col-lg-6">
        <div class="card" v-if="fileData.products">
          <div class="card-header">
            <h3>{{ $t("vehicle_tuning_information") }}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <table class="table table-hover">
                <tbody>
                  <tr>
                    <th scope="row">{{ $t("selected_main_tuning_type") }}</th>
                    <td>
                      <i class="fas fa-chevron-right"></i>
                      {{ fileData.products.short_name }}
                    </td>
                  </tr>
                  <tr v-if="fileData.additional_products">
                    <th scope="row">
                      {{ $t("selected_additional_tuning_types") }}
                    </th>
                    <td>
                      <div
                        v-for="additionalType in fileData.additional_products"
                        :key="additionalType.short_name"
                      >
                        <i class="fas fa-chevron-right"></i>
                        {{ additionalType.short_name }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      fileData.vehicle &&
                      fileData.vehicle.brand &&
                      fileData.vehicle.serie
                    "
                  >
                    <th scope="row">{{ $t("brand_serie") }}</th>
                    <td>
                      {{ fileData.vehicle.brand.name }}
                      {{ fileData.vehicle.serie.name }}
                    </td>
                  </tr>
                  <tr v-if="fileData.vehicle && fileData.vehicle.build">
                    <th scope="row">{{ $t("build_engine") }}</th>
                    <td>
                      {{ fileData.vehicle.build.name }}
                      {{ fileData.vehicle.name }}
                    </td>
                  </tr>
                  <tr v-if="fileData.customer_notes">
                    <th scope="row">Your notes</th>
                    <td>{{ fileData.customer_notes }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h3>{{ $t("related_tickets") }}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <div class="fa-3x text-center" v-if="ticketDataLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <div v-if="tblTicketsUrl && !ticketDataLoading">
              <v-server-table
                :url="tblTicketsUrl"
                :columns="tblTicketsColumns"
                :options="tblTicketsOptions"
                ref="ticketTable"
              >
                <template slot="created_by" slot-scope="props">
                  <div v-if="!props.row.user_id">by customer</div>
                  <div v-else>
                    {{ $t("by_engineer") }} {{ props.row.user_id }}
                  </div>
                </template>
                <template slot="user_status" slot-scope="props">
                  <span
                    @click="setTicketMessageRead(props.row.id)"
                    v-if="props.row.user_status == 'unread'"
                    class="unreadIcon pull-right"
                    :data-tooltip="$t('set_message_read')"
                    ><i class="fas fa-star fa-lg"></i
                  ></span>
                </template>
                <template slot="child_row" slot-scope="props">
                  {{ $t("initial_message") }}: {{ props.row.message
                  }}<br /><br />
                  <div v-if="props.row.children">
                    <div
                      class="childRowTicket"
                      v-for="child in props.row.children"
                      :key="child.id"
                    >
                      <div class="from pull-left">
                        <span v-if="child.direction == 'customer'"
                          ><i class="fas fa-user-cog"></i> Engineer</span
                        ><span v-else><i class="fas fa-user"></i> You</span>
                      </div>
                      <div class="date">{{ child.created_at }}</div>
                      <div class="msg">{{ child.message }}</div>
                    </div>
                  </div>
                  <a
                    class="btn btn-sm btn-primary pull-right"
                    @click="readTicketmessage(props.row.id)"
                    ><i class="fas fa-arrow-alt-circle-right"></i>
                    {{ $t("read_more") }}</a
                  >
                </template>
              </v-server-table>
              <div class="clearfix"></div>
            </div>
            <div v-if="!tblTicketsUrl && !ticketDataLoading">
              <h5>{{ $t("no_tickets") }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>{{ $t("please_load_file_overview") }}</h4>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: ["fileId"],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: function () {
    return {
      ticketDataLoading: false,
      uploadingFile: false,
      fileData: "",
      returnedFiles: "",
      ticketData: "",
      customerData: "",
      productData: "",
      processData: { message: "", credits: "", files: "" },
      columns: ["fuel_type", "name", "slug", "hp", "kw", "actions"],
      tblTicketsOptions: {
        childRow: function (h, row) {
          return row;
        },
      },
      tblTicketsUrl: "",
      tblTicketsColumns: ["created_at", "subject", "status"],
    };
  },
  mounted: function () {},
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    loadFileDetails(fileId) {
      this.ticketDataLoading = true;
      this.fileData = "";
      this.customerData = "";
      Webservice.getFileDetails(fileId).then((response) => {
        this.tblTicketsUrl = "/tickets?file_id=" + fileId;
        this.fileData = response.data;
        if (response.data.customer) {
          this.customerData = response.data.customer;
        }
        if (response.data.stage) {
          this.stageData = response.data.stage;
        }
        if (response.data.product) {
          this.productData = response.data.product;
          this.processData.credits = Math.round(response.data.product.credits);
        }
        if (response.data.status === "completed") {
          //this.toastr.warning('This file has the status completed already', 'File completed');
        } else if (response.data.status === "canceled") {
          //this.toastr.warning('This file has the status canceled. You can continue to deliver the file, the status will be set to completed if you have completed the request', 'File canceled');
        }
        setTimeout(() => {
          this.tblTicketsUrl = APIURL + "/tickets/byfile/" + this.fileId;
          this.ticketDataLoading = false;
        }, 1500);
      });
    },
    downloadFiles(fileId, filename) {
      Webservice.downloadFile(fileId, filename)
        .then((resp) => {
          if (resp.data.byteLength == 19) {
            /* this length is equivalent to "error_low_balance" */
            swal({
              title: this.$t("no_credits"),
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success btn-fill",
              html:
                this.$t("you_havent_downloaded_before") +
                "<br/><br/>" +
                this.$t("click") +
                " <a href='/portal/credits'>" +
                this.$t("here_to_buy_credits") +
                "</a>",
            });
          } else if (resp.data.byteLength == 25) {
            /* this length is equivalent to "error_low_balance" */
            swal({
              title: this.$t("please_contact_account_manager_credits"),
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success btn-fill",
              html:
                this.$t("hasnt_been_downloaded_before_account_updated") +
                ".<br/><br/>" +
                this.$t("please_contact_them_ticket") +
                "</a>",
            });
          } else {
            if (resp.headers) {
              var a = document.createElement("a");
              let contenttype = resp.headers["content-type"];
              var blob = new Blob([resp.data], { type: contenttype });
              var url = window.URL.createObjectURL(blob);

              a.style = "display: none";
              a.href = url;
              if (typeof filename === "undefined") {
                filename = "archive_download_" + fileId;
              }
              a.download = filename;

              document.body.appendChild(a);
              a.click();
              setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }, 1500);
            }
          }
        })
        .catch((err) => {
          swal({
            title: this.$t("something_went_wrong"),
            buttonsStyling: false,
            confirmButtonClass: "btn btn-error btn-fill",
            html:
              this.$t(
                "there_went_something_wrong_please_try_individual_files"
              ) +
              ".<br/><br/>" +
              this.$t("if_persists_contact_account_manager") +
              "<br/>(" +
              err +
              ")",
          });
        });
    },
    readTicketmessage(ticketId) {
      this.$router.push({ name: "Tickets", params: { ticketId: ticketId } });
    },
  },
};
</script>
<style scoped>
.childRowTicket {
  padding-left: 50px;
  width: 100%;
  border-bottom: 1px solid #c0c0c0;
  padding-bottom: 15px;
}
.childRowTicket .date {
  float: right;
  width: 250px;
}
.childRowTicket .msg {
  border-top: 1px solid #ccc;
  width: 100%;
  clear: both;
}
.credits {
  font-size: 0.8em;
  float: right;
  color: #c0c0c0;
  padding-right: 20px;
}
.adminNotes {
  color: #868686;
  padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/file.vue